import React, { Fragment, useRef, useState, useEffect, forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Col, Row, Spin, message } from 'antd';
import Carousel from 'ReusableComponents/Carousel/Carousel';
import cloneDeep from 'lodash/cloneDeep';
import PreloadedImage from 'ReusableComponents/PreloadedImage';

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, language, checkAnswer, } = props,
    { required, questions, defaultValue, id, mediaFiles } = inputData,
    { getFieldDecorator } = form;
  const carouselRef = useRef();

  useEffect(() => {
    if (checkAnswer && carouselRef.current) carouselRef.current.next();
  }, [checkAnswer]);

  return (
    <FormItem>
      {getFieldDecorator(id, {
        initialValue: defaultValue,
        rules: [
          {
            required,
            message: "Required Field"
          }
        ]
      })(
        <Row type="flex" justify="center" align="middle">
          <Carousel ref={carouselRef} animation={"fade"}>
            {
              mediaFiles.map((mediaFile, index) => {
                return (
                  <Fragment key={index}>
                    <Col style={{ height: '100%', }}>
                      <PreloadedImage width={index === 0 ? "6vw" : "24vw"} image={mediaFile.src} />
                    </Col>
                  </Fragment>
                )
              })
            }
          </Carousel>
        </Row>
      )}
    </FormItem>
  );
});
